import statuses from '@/store/statuses';
import Services from '@/services/index';
import VuexTypes from '@/store/types/index';
import { Backend } from '@/_axios';

const AuthService = Services.auth;
const AuthTypes = VuexTypes.auth;
export default {
  [AuthTypes.LOAD_USER_INFO]: ({ commit }) => {
    AuthService.user().then(({ data }) => {
      commit(AuthTypes.SET_INFO, data);
    }).catch((errResponse) => {
      console.log(errResponse);
    });
  },
  [AuthTypes.LOGOUT]: ({ commit }) => {
    return new Promise((resolve) => {
      commit(AuthTypes.SET_TOKEN, null);
      resolve();
    });
  },
  [AuthTypes.UPDATE_TOKEN]: ({ commit }, token) => {
    return new Promise((resolve) => {
      commit(AuthTypes.SET_TOKEN, token);
      Backend.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      resolve();
    });
  },
  [AuthTypes.REGISTER]: ({ commit, state }, createData) => {
    state.register['status'] = statuses.LOADING;
    AuthService.register(createData).then((data) => {
      commit(AuthTypes.REGISTER, data);
    }).catch((errResponse) => {
      commit(AuthTypes.REGISTER, errResponse);
    });
  },
  [AuthTypes.FORGOT_PASSWORD]: ({ commit, state }, emailData) => {
    state.forgotPassword['status'] = statuses.LOADING;
    AuthService.forgotPassword(emailData).then((data) => {
      commit(AuthTypes.FORGOT_PASSWORD, data);
    }).catch((errResponse) => {
      commit(AuthTypes.FORGOT_PASSWORD, errResponse);
    });
  },
  [AuthTypes.RESET_PASSWORD]: ({ commit, state }, resetData) => {
    state.resetPassword['status'] = statuses.LOADING;
    AuthService.resetPassword(resetData).then((data) => {
      commit(AuthTypes.RESET_PASSWORD, data);
    }).catch((errResponse) => {
      commit(AuthTypes.RESET_PASSWORD, errResponse);
    });
  },
};
